import { ComponentProps, JSXElementConstructor } from 'react';
import {
  Modal,
  registerModals,
  registerNavigationHandlers,
} from '@bonanza-social/navigation';
import { PrizeWallCampaignNavigatorParamsList } from '../navigators/PrizeWallCampaignNavigator/PrizeWallCampaignNavigator.types';
import { PrizeWallAwardModal, PrizeWallQuickRulesModal } from '../modals';

import './index.shared';

registerNavigationHandlers<
  PrizeWallCampaignNavigatorParamsList,
  | 'PrizeWallScreen'
  | 'PrizeWallInfoScreen'
  | 'PrizeWallAwardScreen'
  | 'PrizeWallWinnersScreen'
  | 'PrizeWallQuickRulesScreen'
>({
  PrizeWallScreen(navigate) {
    navigate('/prize-wall');
  },
  PrizeWallInfoScreen(navigate) {
    navigate('/prize-wall/info');
  },
  PrizeWallAwardScreen(_, data) {
    Modal.open({
      namespace: 'prizeWall',
      type: 'PrizeWallAward',
      options: {
        variant: 'transparent',
        animated: false,
        hideHeader: true,
      },
      style: {
        width: '100%',
        height: '100%',
        maxWidth: 'auto',
        maxHeight: 'auto',
        borderRadius: 'radius-0',
      },
      data,
    });
  },
  PrizeWallWinnersScreen(navigate) {
    navigate('/prize-wall/winners');
  },
  PrizeWallQuickRulesScreen() {
    Modal.open({
      namespace: 'prizeWall',
      type: 'PrizeWallQuickRules',
      options: {
        hideHeader: true,
      },
      style: {
        width: {
          mobile: '100%',
          tablet: 440,
          desktop: 440,
        },
        height: {
          mobile: '100%',
          tablet: '100%',
          desktop: 704,
        },
      },
    });
  },
});

const modals = {
  PrizeWallAward: PrizeWallAwardModal,
  PrizeWallQuickRules: PrizeWallQuickRulesModal,
};

registerModals('prizeWall', modals);

declare global {
  interface RegisteredModals {
    prizeWall: {
      [K in keyof typeof modals]: JSXElementConstructor<
        ComponentProps<(typeof modals)[K]>
      >;
    };
  }
}
